import { ActualsValueTypes } from 'partner360/models/actualValueTypes'
import { P360Currency } from 'partner360/models/P360Currency'

export const getNdpUsdField = (field: string) => {
  return `${field}${ActualsValueTypes.Ndp}${P360Currency.USD}`
}
